import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import {
  OnboardingLegalClientDocument,
  useLegalClientCompleteBranchOnboardingMutation,
} from 'api/generated/graphql';
import { useError } from 'api/helpers';

export const useLegalClientCompleteBranchOnboarding = () => {
  const [handle, { loading, error: apolloError }] =
    useLegalClientCompleteBranchOnboardingMutation({
      refetchQueries: [OnboardingLegalClientDocument],
      awaitRefetchQueries: true,
    });

  const error = useError(apolloError);

  const complete = useCallback(
    async (legalId: string, branchId: string) => {
      const res = await handle({
        variables: { id: legalId, branchId },
      });
      return !!res.data?.legalClientCompleteBranchOnboarding;
    },
    [handle]
  );

  return {
    loading,
    error,
    complete,
  };
};
